import { AlertService } from './../../core/services/alert.service';
import { ApiObjectData } from './../../core/models/api-object-data';
import { Teacher } from './../../core/models/teacher';
import { Component, ContentChild, ElementRef, OnInit, Pipe, ViewChild } from '@angular/core';
import { BaseComponent } from './../../components/base/base.component';
import { BaseService } from './../../core/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { TeacherService } from '../../core/services/teacher.service';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NG_VALIDATORS, Validator, AbstractControl,ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-become-teacher',
  templateUrl: './become-teacher.component.html',
  styleUrls: ['./become-teacher.component.scss']
})
export class BecomeTeacherComponent extends BaseComponent implements OnInit {
  @ViewChild('teacherForm', { static: false }) teacherForm: NgForm;
  teacher = {} as Teacher
  tokenValid = false;
  
  constructor(
    public baseService:BaseService,
    private teacherService: TeacherService,
    private alertService: AlertService,
    private route :ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
  ) { super() }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(){
    const token = localStorage.getItem('token');
    const isTeacher = localStorage.getItem('isTeacher');
    if (token && isTeacher) { this.tokenValid = true; }
    else { this.tokenValid = false; }
  }

  registerTeacher() {
    this.teacher.name = this.teacher.firstName;
    this.teacher.surname = this.teacher.lastName;
    this.teacher.emailAddress = this.teacher.email;
    this.baseService.blockStart();
    this.teacherService.save(this.teacher).pipe(takeUntil(this.ngUnsubscribe)).subscribe (
      (data: any) => {
        this.baseService.blockStop();
        if (data.result.message.type === 'Success') {
          this.alertService.success(this.translate.instant('registeredSuccessfully'));
          this.teacher = {} as Teacher;
          this.teacherForm.reset(this.teacher);
          this.router.navigate(['/login']);
        }
        else if (data.result.message.type === 'Error') {
          this.alertService.error(data.result.message.log)
        }
        else {
          this.alertService.error(data.result.returnData);
        }
      },
      error => {
        this.baseService.blockStop();
        this.alertService.error(this.translate.instant('loginerror'));
      }
    )
  }

  changeInput(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
  }

}
